<template>
    <div class="popular-brand d-flex flex-column flex-md-row" :class="{ 'flex-md-column': vertical }">
        <router-link :to="$brand.getPath(brand)" class="image p-4 d-flex justify-content-center align-items-center">
            <div class="inset-shadow">
                <UIImage
                    :src="$brand.getImage200(brand)"
                    :resource="true"
                    :alt="$brand.getName(brand)"
                    :width="165"
                    :height="115"
                />
            </div>
            <div class="name font-weight-bold">
                <span>{{ $brand.getName(brand) }}</span>
            </div>
        </router-link>
        <div class="prices p-3 p-md-4 flex-grow-1 d-flex align-items-center">
            <div class="w-100">
                <div class="font-weight-bold mb-1">{{ translate('availableValues') }}:</div>
                <div class="prices-wrapper d-flex">
                    <span
                        v-for="product in brand.products"
                        :key="product.id"
                        class="mr-2 d-inline-block"
                        :class="{ 'no-stock': !product.stock }"
                        @click.prevent.stop="navigateToProductPage(product)"
                        >{{ $product.getTextValue(product) }}</span
                    >
                </div>
                <UIButton variant="primary" :to="$brand.getPath(brand)" class="mt-3 w-100">{{
                    translate('giftcard.orderNowBtn')
                }}</UIButton>
            </div>
        </div>
    </div>
</template>
<script>
import { UIButton, UIImage } from '@dundle/ui/components';
import TranslationMixin from '~/mixins/TranslationMixin';

export default {
    components: {
        UIButton,
        UIImage,
    },

    mixins: [TranslationMixin],

    props: {
        brand: {
            type: Object,
            required: true,
        },
        vertical: {
            type: Boolean,
            default: false,
        },
    },

    methods: {
        navigateToProductPage(product) {
            if (product.stock) this.$router.push(this.$product.getPath({ ...product, brand: this.brand }));
        },
    },
};
</script>

<style lang="scss" scoped>
@import '../../assets/styles/imageUtils.scss';

.popular-brand {
    position: relative;
    width: 100%;
    border: 1px solid $color-grey-3;

    .image {
        background: $color-grey-1;
        min-width: 50%;
        position: relative;

        .inset-shadow {
            position: relative;

            &:after {
                position: absolute;
                content: '';
                top: 0;
                right: 0;
                left: 0;
                height: 100%;
                @include calculate-image-border-radius(10%);
                box-shadow: inset 0 0 1px rgba(0, 0, 0, 0.5), inset 0 1px hsla(0, 0%, 100%, 0),
                    inset 0 0.3rem 0.6rem hsla(0, 0%, 100%, 0.1), inset 0 -0.5rem 2rem rgba(0, 0, 0, 0.2);
            }

            img {
                @include calculate-image-border-radius(10%);
                max-width: 165px;
            }
        }
    }

    .name {
        font-size: 1.3rem;
        position: absolute;
        left: 1.5rem;
        bottom: 0.7rem;

        span {
            box-shadow: 0 0 0 4px #fff, 0 1px 2px 4px rgba(0, 0, 0, 0.1);
            background-color: #fff;
            line-height: 1.9;
        }
    }

    .prices {
        overflow: hidden;

        & > div {
            overflow: hidden;
        }

        .prices-wrapper {
            position: relative;
            overflow: hidden;

            &:after {
                content: '';
                position: absolute;
                top: 0;
                right: 0;
                bottom: 0;
                z-index: 1;
                width: 50%;
                height: 100%;
                background-image: linear-gradient(90deg, transparent 0%, #fff 100%);
                pointer-events: none;
            }
        }

        span {
            border: 1px solid $color-grey-3;
            color: $color-header-link-hover;
            font-size: 0.8rem;
            font-weight: bold;
            border-radius: 2px;
            padding: 0.2rem 0.6rem;

            &.no-stock {
                color: rgba($color-grey-4, 0.7) !important;
                border-color: rgba($color-button-border, 0.5);
                background: $color-button;
                font-weight: normal;
                cursor: not-allowed;
            }

            &:not(.no-stock):hover {
                text-decoration: none;
                color: $color-text-inverted !important;
                background-color: $color-primary !important;
                border: 1px solid $color-primary;
                cursor: pointer;
            }
        }
    }
}
</style>

<i18n src="@dundle/locale/data/giftcard.json"></i18n>
<i18n></i18n>
